import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

/**
 * Esquema `work` de footprints (solo dashboard): en los entornos con
 * `footprintsSchema: 'work'`, las pantallas de huella y de revisión de viajes
 * leen las tablas auditadas de Predictland. Reescribe `/api/backoffice/` a
 * `/api/backoffice/work/` en los endpoints de la lista, y solo desde esas
 * pantallas (no desde los datos en bruto). Antes iba dentro de AuthInterceptor.
 */
@Injectable()
export class WorkSchemaInterceptor implements HttpInterceptor {
  private readonly router = inject(Router);

  private static readonly WORK_ENDPOINTS = [
    '/api/backoffice/footprint/users',
    '/api/backoffice/users',
    '/api/backoffice/footprint/segment',
    '/api/backoffice/footprint/user/',
    '/api/backoffice/footprint-segment/',
    '/api/backoffice/footprint/tag',
  ];

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (environment.footprintsSchema !== 'work') {
      return next.handle(req);
    }

    const currentUrl = this.router.url;
    const isTargetView = currentUrl.includes('/admin/footPrint') || currentUrl.includes('/admin/travelReview');
    const isRawDataView = currentUrl.includes('/admin/footPrint/raw-data');
    const matchesWhitelist = WorkSchemaInterceptor.WORK_ENDPOINTS.some((endpoint) => req.url.includes(endpoint));

    if (isTargetView && !isRawDataView && matchesWhitelist) {
      return next.handle(req.clone({ url: req.url.replace('/api/backoffice/', '/api/backoffice/work/') }));
    }
    return next.handle(req);
  }
}
